<template>
    <div v-show="pages > 1" class="inline-flex items-center gap-2 whitespace-nowrap">
        <span>Stránka</span>

        <button 
            :disabled="value <= 1 || disabled"
            @click="handlePrevious"
            class="p-1 rounded hover:bg-gray-100 hover:dark:bg-subtle disabled:opacity-50 disabled:cursor-not-allowed"
        >
            <svg class="size-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
        </button>

        <CFormSelect class="w-auto" :options="options" :value="value" @input="handlePageChange" />

        <button 
            :disabled="value >= pages || disabled"
            @click="handleNext"
            class="p-1 rounded hover:bg-gray-100 hover:dark:bg-subtle disabled:opacity-50 disabled:cursor-not-allowed"
        >
            <svg class="size-4" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
            </svg>
        </button>

        <span class="hidden md:block">z {{ pages }}</span>
    </div>
</template>

<script setup lang="ts">
import range from 'lodash-es/range'

const props = defineProps({
    value: {
        type: Number,
        required: true
    },
    pages: {
        type: Number,
        required: true
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['input'])

const options = computed(() => {
    return range(1, props.pages + 1)
})

function handlePageChange(value: string | number) {
    const pageNumber = typeof value === 'string' ? parseInt(value, 10) : value
    emit('input', pageNumber)
}

function handlePrevious() {
    if (props.value > 1) {
        emit('input', props.value - 1)
    }
}

function handleNext() {
    if (props.value < props.pages) {
        emit('input', props.value + 1)
    }
}
</script>